<div class="page-container">
  <div class="header-section">
    <div class="title-block">
      <h1>
        {{
          isReadonly()
            ? "Inspection Details"
            : inspection.inspectionId > 0
              ? "Edit Inspection"
              : "Create New Inspection"
        }}
      </h1>
      <div class="subtitle" *ngIf="isReadonly()">
        <span *ngIf="isReadonly()" class="readonly-tag">
          <span class="material-icons">lock</span>
          {{ statusLabel() }} · read-only
        </span>
      </div>
      <div
        *ngIf="inspection?.startedBy || inspection?.startedDate"
        class="audit-info"
      >
        <span class="material-icons">play_circle</span>
        Started
        <ng-container *ngIf="startedByName() as name">
          by <strong>{{ name }}</strong>
        </ng-container>
        <ng-container *ngIf="inspection?.startedDate">
          on {{ inspection.startedDate | date:'dd.MM.yyyy HH:mm' }}
        </ng-container>
      </div>
    </div>
    <div class="header-actions">
      <button
        class="btn-secondary"
        (click)="isReadonly() ? cancelEdit() : openCancelDialog()"
      >
        <span class="material-icons">arrow_back</span> Back
      </button>
      <button
        *ngIf="!isReadonly()"
        class="btn-primary"
        (click)="saveInspection()"
      >
        <span class="material-icons">save</span> Save
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner styleClass="labtech-spinner" ariaLabel="Loading"></p-progressSpinner>
    <p>Loading inspection details...</p>
  </div>

  <div class="detail-container" *ngIf="!loading && inspection">
    <form>
      <div class="form-card mb-4">
        <div class="d-flex justify-content-start align-items-center mb-4">
          <span class="material-icons me-2">info</span>
          <h3 class="card-title mb-0">Basic Information</h3>
        </div>
        <div class="card-content">
          <div class="form-grid-layout">
            <div class="form-group">
              <label class="form-label"
                >Report Number <span class="required">*</span></label
              >
              <input pInputText
                [(ngModel)]="inspection.reportNumber"
                name="reportNumber"
                placeholder="Enter report number"
                class="form-input"
                [disabled]="isReadonly()"
                [class.validation-error]="
                  showValidationErrors &&
                  (!inspection.reportNumber ||
                    inspection.reportNumber.trim() === '')
                "
               />
              <div class="hint">Nur numerische Report Number möglich.</div>
            </div>
            <div class="form-group">
              <label class="form-label">Order Number</label>
              <input
                pInputText
                [(ngModel)]="inspection.orderNumber"
                name="orderNumber"
                placeholder="Enter order number"
                class="form-input"
                [disabled]="isReadonly()"
              />
            </div>
            <div class="form-group">
              <label class="form-label"
                >Title <span class="required">*</span></label
              >
              <input
                pInputText
                [(ngModel)]="inspection.title"
                name="title"
                placeholder="Enter inspection title"
                class="form-input"
                [disabled]="isReadonly()"
                [class.validation-error]="
                  showValidationErrors &&
                  (!inspection.title || inspection.title.trim() === '')
                "
              />
            </div>
            <div class="form-group">
              <label class="form-label"
                >Inspection Date <span class="required">*</span></label
              >
              <p-datepicker
                [(ngModel)]="inspectionDate"
                name="inspectionDate"
                dateFormat="dd.mm.yy"
                placeholder="Select date"
                class="form-input"
                [disabled]="isReadonly()"
                [class.validation-error]="
                  showValidationErrors && !inspection.inspectionDate
                "
              ></p-datepicker>
            </div>
            <div class="form-group">
              <label class="form-label">Report Finalization Date</label>
              <p-datepicker
                [(ngModel)]="reportFinalizationDate"
                name="reportFinalizationDate"
                dateFormat="dd.mm.yy"
                placeholder="Select date"
                class="form-input"
                [disabled]="isReadonly()"
              ></p-datepicker>
            </div>
          </div>
        </div>
      </div>

      <div class="cards-grid-layout">
        <div class="form-card">
          <div class="d-flex justify-content-start align-items-center mb-4">
            <span class="material-icons me-2">business</span>
            <h3 class="card-title">Customer Information</h3>
          </div>
          <div class="card-content">
            <div class="form-group mb-3">
              <label class="form-label"
                >Customer <span class="required">*</span></label
              >
              <p-select [filter]="true"
                [options]="inspection.customerList"
                [(ngModel)]="inspection.customer"
                name="customer"
                optionLabel="title"
               
               
                [disabled]="isReadonly() || isCustomerDisabled()"
                (ngModelChange)="onCustomerChange($event)"
               
                class="form-input"
                [class.validation-error]="
                  showValidationErrors && !inspection.customer?.customerId
                "
              ></p-select>
              <div class="hint" *ngIf="isCustomerDisabled()">
                Customer can't be changed after save.
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">Customer Contact Person</label>
              <p-select [filter]="true"
                [options]="inspection.customerContactPersonList"
                [(ngModel)]="inspection.customerContactPerson"
                name="customerContactPerson"
                optionLabel="firstName"
               
               
                [disabled]="isReadonly() || !inspection.customer"
               
                class="form-input"
              >
                <ng-template pTemplate="item" let-dataItem
                  >{{ dataItem.firstName }} {{ dataItem.lastName }}</ng-template
                >
                <ng-template pTemplate="selectedItem" let-dataItem>
                  <span *ngIf="dataItem.firstName"
                    >{{ dataItem.firstName }} {{ dataItem.lastName }}</span
                  >
                  <span *ngIf="!dataItem.firstName">{{ dataItem }}</span>
                </ng-template>
              </p-select>
            </div>
          </div>
        </div>

        <div class="form-card">
          <div class="d-flex justify-content-start align-items-center mb-4">
            <span class="material-icons me-2">factory</span>
            <h3 class="card-title">Factory Information</h3>
          </div>
          <div class="card-content">
            <div class="form-group mb-3">
              <label class="form-label"
                >Factory <span class="required">*</span></label
              >
              <p-select [filter]="true"
                [options]="inspection.factoryList"
                [(ngModel)]="inspection.factory"
                name="factory"
                optionLabel="title"
               
               
                [disabled]="isReadonly()"
                (ngModelChange)="onFactoryChange($event)"
               
                class="form-input"
                [class.validation-error]="
                  showValidationErrors && !inspection.factory?.factoryId
                "
              ></p-select>
            </div>
            <div class="form-group">
              <label class="form-label">Factory Contact Person</label>
              <p-select [filter]="true"
                [options]="inspection.factoryContactPersonList"
                [(ngModel)]="inspection.factoryContactPerson"
                name="factoryContactPerson"
                optionLabel="firstName"
               
               
                [disabled]="isReadonly() || !inspection.factory"
               
                class="form-input"
              >
                <ng-template pTemplate="item" let-dataItem
                  >{{ dataItem.firstName }} {{ dataItem.lastName }}</ng-template
                >
                <ng-template pTemplate="selectedItem" let-dataItem>
                  <span *ngIf="dataItem.firstName"
                    >{{ dataItem.firstName }} {{ dataItem.lastName }}</span
                  >
                  <span *ngIf="!dataItem.firstName">{{ dataItem }}</span>
                </ng-template>
              </p-select>
            </div>
          </div>
        </div>

        <div class="form-card">
          <div class="d-flex justify-content-start align-items-center mb-4">
            <span class="material-icons me-2">assignment</span>
            <h3 class="card-title">Inspection Details</h3>
          </div>
          <div class="card-content">
            <div class="form-grid-layout">
              <div class="form-group full-width">
                <label class="form-label"
                  >Inspection Type <span class="required">*</span></label
                >
                <p-select [filter]="true"
                  [options]="inspection.inspectionTypeList"
                  [(ngModel)]="inspection.inspectionType"
                  name="inspectionType"
                  optionLabel="title"
                 
                 
                  (ngModelChange)="onInspectionTypeChange($event)"
                  [disabled]="
                    isReadonly() ||
                    isCustomerDisabled() ||
                    inspection.customer === null
                  "
                 
                  class="form-input"
                  [class.validation-error]="
                    showValidationErrors &&
                    !inspection.inspectionType?.auditTypeId
                  "
                ></p-select>
                <div class="hint" *ngIf="isCustomerDisabled()">
                  Inspection Type can't be changed after save.
                </div>
              </div>
              <div class="form-group">
                <label class="form-label">Testing Institute</label>
                <p-select [filter]="true"
                  [options]="inspection.testingInstituteList"
                  [(ngModel)]="inspection.testingInstitute"
                  name="testingInstitute"
                  optionLabel="title"
                 
                 
                  [disabled]="isReadonly()"
                 
                  class="form-input"
                ></p-select>
              </div>
              <div class="form-group">
                <label class="form-label">Sample Institute</label>
                <p-select [filter]="true"
                  [options]="inspection.testingInstituteList"
                  [(ngModel)]="inspection.sampleInstitute"
                  name="sampleInstitute"
                  optionLabel="title"
                 
                 
                  [disabled]="isReadonly()"
                 
                  class="form-input"
                ></p-select>
              </div>
              <div class="form-group">
                <label class="form-label">Inspection Level</label>
                <p-select [filter]="true"
                  [options]="inspection.inspectionLevelList"
                  [(ngModel)]="inspection.inspectionLevel"
                  [disabled]="isReadonly() || isCustomerDisabled()"
                  name="inspectionLevel"
                  optionLabel="title"
                 
                 
                  (ngModelChange)="onInspectionLevelChange($event)"
                 
                  class="form-input"
                  [class.validation-error]="
                    showValidationErrors &&
                    !!inspection.quantity &&
                    !inspection.inspectionLevel?.inspectionLevelId
                  "
                ></p-select>
                <div class="hint" *ngIf="isCustomerDisabled()">
                  Inspection Level can't be changed after save.
                </div>
              </div>
              <div class="form-group">
                <label class="form-label">LOT Size / Quantity</label>
                <p-inputNumber
                  [(ngModel)]="inspection.quantity"
                  name="quantity"
                 
                  [min]="1"
                  class="form-input"
                  [disabled]="isReadonly()"
                  (ngModelChange)="onQuantityChange($event)"
                  [class.validation-error]="
                    showValidationErrors &&
                    !!inspection.inspectionLevel?.inspectionLevelId &&
                    !inspection.quantity
                  "
                 [minFractionDigits]="0" [maxFractionDigits]="0"></p-inputNumber>
                <div class="hint">Basis für AQL-Berechnung.</div>
              </div>
              <div class="form-group full-width" *ngIf="inspection.aqlData as aqlData">
                <div class="aql-preview-card">
                  <div class="aql-preview-header">
                    <span class="material-icons">query_stats</span>
                    <span>AQL Preview</span>
                  </div>
                  <div class="aql-preview-grid">
                    <div class="aql-preview-item">
                      <span class="aql-preview-label">Code Letter</span>
                      <strong>{{ aqlData.codeLetter }}</strong>
                    </div>
                    <div class="aql-preview-item">
                      <span class="aql-preview-label">Sample Size</span>
                      <strong>{{ aqlData.sampleSize }}</strong>
                    </div>
                    <div class="aql-preview-item">
                      <span class="aql-preview-label">Allowed Critical</span>
                      <strong>{{ aqlData.allowedCriticalFailure }}</strong>
                    </div>
                    <div class="aql-preview-item">
                      <span class="aql-preview-label">Allowed Major</span>
                      <strong>{{ aqlData.allowedMajorFailure }}</strong>
                    </div>
                    <div class="aql-preview-item">
                      <span class="aql-preview-label">Allowed Minor</span>
                      <strong>{{ aqlData.allowedMinorFailure }}</strong>
                    </div>
                    <div class="aql-preview-item">
                      <span class="aql-preview-label">Quantity</span>
                      <strong>{{ aqlData.quantity }}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group full-width">
                <label class="form-label"
                  >Count of Measurements
                  <span *ngIf="requiresMeasurementCount()" class="required"
                    >*</span
                  ></label
                >
                <p-inputNumber
                  [(ngModel)]="inspection.countOfMeasurements"
                  name="countOfMeasurements"
                 
                  [min]="requiresMeasurementCount() ? 1 : 0"
                  class="form-input"
                  [disabled]="isReadonly()"
                  [class.validation-error]="
                    showValidationErrors &&
                    requiresMeasurementCount() &&
                    !hasValidMeasurementCount()
                  "
                 [minFractionDigits]="0" [maxFractionDigits]="0"></p-inputNumber>
                <div class="hint" *ngIf="requiresMeasurementCount()">
                  Pflichtfeld für Inspektionstypen mit Measurements, Standardwert 3.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-card">
          <div class="d-flex justify-content-start align-items-center mb-4">
            <span class="material-icons me-2">groups</span>
            <h3 class="card-title">Inspector Assignment</h3>
          </div>
          <div class="card-content">
            <div class="form-grid-layout">
              <div class="form-group">
                <label class="form-label">Primary Inspector</label>
                <p-select [filter]="true"
                  [options]="inspection.inspectorList"
                  [(ngModel)]="inspection.primaryInspector"
                  name="primaryInspector"
                  optionLabel="username"
                 
                 
                  [disabled]="isReadonly()"
                  (ngModelChange)="onPrimaryInspectorChange($event)"
                 
                  class="form-input"
                >
                  <ng-template pTemplate="item" let-dataItem>
                    {{ getInspectorDisplayName(dataItem) }}
                  </ng-template>
                  <ng-template pTemplate="selectedItem" let-dataItem>
                    <span *ngIf="dataItem?.id; else emptyPrimaryInspector">
                      {{ getInspectorDisplayName(dataItem) }}
                    </span>
                  </ng-template>
                </p-select>
                <ng-template #emptyPrimaryInspector>
                  <span>Select Primary Inspector</span>
                </ng-template>
              </div>
              <div class="form-group">
                <label class="form-label">Additional Inspectors</label>
                <p-multiSelect [filter]="true"
                  [options]="inspection.inspectorList"
                  [(ngModel)]="inspection.additionalInspectors"
                  name="additionalInspectors"
                  optionLabel="username"
                 
                 
                  [disabled]="isReadonly()"
                  (ngModelChange)="onAdditionalInspectorsChange($event)"
                  class="form-input"
                 display="chip">
                  <ng-template pTemplate="item" let-dataItem>
                    {{ getInspectorDisplayName(dataItem) }}
                  </ng-template>
                  <ng-template pTemplate="selectedItems" let-selectedInspectors>
                    {{ getInspectorDisplayNames(selectedInspectors) }}
                  </ng-template>
                </p-multiSelect>
                <div class="hint">0 bis n zusätzliche Inspektoren möglich.</div>
              </div>
              <div class="form-group full-width" *ngIf="inspection.primaryInspector || inspection.additionalInspectors.length">
                <div class="inspector-summary-card">
                  <div class="inspector-summary-label">Assigned Inspectors</div>
                  <div class="inspector-chip-list">
                    <span class="inspector-chip inspector-chip--primary" *ngIf="inspection.primaryInspector as primaryInspector">
                      <span class="material-icons">star</span>
                      {{ getInspectorDisplayName(primaryInspector) }}
                    </span>
                    <span class="inspector-chip" *ngFor="let inspector of inspection.additionalInspectors">
                      <span class="material-icons">person</span>
                      {{ getInspectorDisplayName(inspector) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-card">
          <div class="d-flex justify-content-start align-items-center mb-4">
            <span class="material-icons me-2">inventory_2</span>
            <h3 class="card-title">Packing Information</h3>
          </div>
          <div class="card-content">
            <div class="form-grid-layout three-columns">
              <div class="form-group">
                <label class="form-label">WIDTH (CM)</label>
                <p-inputNumber
                  [(ngModel)]="inspection.packingWidth"
                  name="packingWidth"
                 
                  [min]="0"
                  [step]="0.1"
                  class="form-input"
                  [disabled]="isReadonly()"
                 [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
              </div>
              <div class="form-group">
                <label class="form-label">HEIGHT (CM)</label>
                <p-inputNumber
                  [(ngModel)]="inspection.packingHeight"
                  name="packingHeight"
                 
                  [min]="0"
                  [step]="0.1"
                  class="form-input"
                  [disabled]="isReadonly()"
                 [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
              </div>
              <div class="form-group">
                <label class="form-label">LENGTH (CM)</label>
                <p-inputNumber
                  [(ngModel)]="inspection.packingLength"
                  name="packingLength"
                 
                  [min]="0"
                  [step]="0.1"
                  class="form-input"
                  [disabled]="isReadonly()"
                 [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-card article-overview-card">
        <div class="article-section-header">
          <div>
            <div class="d-flex justify-content-start align-items-center mb-2">
              <span class="material-icons me-2">category</span>
              <h3 class="card-title mb-0">Inspection Articles</h3>
            </div>
            <p class="article-section-subtitle mb-0">
              Articles are shown as tiles. Create and edit actions stay directly on this page with inline editing for sizes and measurement matrix.
            </p>
          </div>

          <button
            *ngIf="!isReadonly()"
            type="button"
            class="btn-primary article-add-btn"
            (click)="addInspectionArticle()"
          >
            <span class="material-icons">add</span>
            Add Article
          </button>
        </div>

        <div class="card-content">
          <div
            *ngIf="
              (!inspection.inspectionArticles ||
                inspection.inspectionArticles.length === 0) &&
              !articleEditorOpen
            "
            class="empty-state"
          >
            <span class="material-icons empty-icon">inventory_2</span>
            <h3>No articles available yet</h3>
            <p>Create the first article for this inspection.</p>
          </div>

          <div
            *ngIf="
              inspection.inspectionArticles &&
              inspection.inspectionArticles.length > 0
            "
            class="cards-grid article-cards-grid"
          >
            <div
              class="card article-card"
              *ngFor="let article of inspection.inspectionArticles; let i = index"
            >
              <div class="article-card-top-row">
                <div class="article-card-copy">
                  <div class="article-card-label">Article Type</div>
                  <div class="article-card-value article-card-value--strong">
                    {{
                      article.articleTypeTitleDe ||
                        article.articleTypeTitleEn ||
                        'Not selected'
                    }}
                  </div>

                  <div class="article-card-label">Title</div>
                  <div class="article-card-value">
                    {{ article.title || 'Untitled' }}
                  </div>

                  <div class="article-card-label">Quantity</div>
                  <div class="article-card-value">{{ article.quantity || 0 }}</div>
                </div>

                <div class="article-card-preview" *ngIf="article.imageUrl; else articlePlaceholder">
                  <img
                    [src]="article.imageUrl"
                    [alt]="article.title || 'Article image'"
                    class="article-card-preview-image"
                  />
                </div>

                <ng-template #articlePlaceholder>
                  <div class="article-card-preview article-card-preview--empty">
                    <span class="material-icons">inventory_2</span>
                    <span>No image</span>
                  </div>
                </ng-template>
              </div>

              <div class="article-size-inline">
                <span class="article-size-inline-label">Sizes</span>
                <span class="article-size-inline-value">{{
                  getInspectionArticleSizesText(article)
                }}</span>
              </div>

              <div class="card-footer article-card-footer" *ngIf="!isReadonly()">
                <button
                  type="button"
                  class="card-action-btn"
                  (click)="editInspectionArticle(article)"
                >
                  <span class="material-icons">edit</span>
                  Edit
                </button>

                <button
                  type="button"
                  class="btn-delete"
                  (click)="deleteInspectionArticle(i)"
                >
                  <span class="material-icons">delete</span>
                  Remove
                </button>
              </div>
            </div>
          </div>

          <div class="article-inline-editor-host" *ngIf="articleEditorOpen">
            <app-inspection-article-dialog
              [inlineMode]="true"
              [inspectionIdInput]="inspection.inspectionId"
              [inspectionArticleIdInput]="editingInspectionArticleId"
              (saved)="onInspectionArticleSaved()"
              (canceled)="onInspectionArticleEditorCanceled()"
            ></app-inspection-article-dialog>
          </div>
        </div>
      </div>
    </form>
  </div>

  <p-dialog [modal]="true" [visible]="true"
    *ngIf="cancelDialog"
    header="Cancel Changes"
    (onHide)="toggleCancelDialog()"
   
    [style]="{ width: '450px' }"
  >
    <p style="margin: 30px; font-weight: 500; text-align: center">
      Are you sure you want to cancel? All unsaved changes will be lost.
    </p>
    <ng-template pTemplate="footer">
      <button class="btn-secondary" (click)="toggleCancelDialog()">No</button>
      <button class="btn-primary" (click)="cancelHandler()">Yes</button>
    </ng-template>
  </p-dialog>
</div>
